import type { LexSelectionContext } from '@/features/lexRuntime/types/runtime';

export const MATTER_INTELLIGENCE_SELECTION_EVENT = 'edgelex:matter-intelligence-selection';

export interface MatterIntelligenceSelectionEventDetail {
  selection: LexSelectionContext;
  position: {
    top: number;
    left: number;
  };
}

export function dispatchMatterIntelligenceSelection(
  detail: MatterIntelligenceSelectionEventDetail,
): void {
  window.dispatchEvent(new CustomEvent<MatterIntelligenceSelectionEventDetail>(
    MATTER_INTELLIGENCE_SELECTION_EVENT,
    { detail },
  ));
}
